import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ReusableInput from "components/Inputs/ReusableInput";
import GradientButton from "components/Buttons/GradientButton";
import { Box, HStack, Text, Checkbox } from "@chakra-ui/react";
import { sendNotificationAction, fetchAllNotificationsAction } from "state/actions/notificationActions";
import { useCustomNotification } from "components/Toasts/OpenNotification";

const userOptions = [
  { value: "Admin", label: "Admin" },
  { value: "Driver", label: "Drivers" },
  { value: "Individual", label: "Individuals" },
  { value: "Business", label: "Businesses" },
];

const AddNotificationDrawer = ({ formData, setFormData, onClose }) => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.notifications.loading);
  const notify = useCustomNotification();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleUserToggle = (value) => {
    setFormData((prev) => {
      const currentTargetUsers = prev.targetUsers || [];
      if (currentTargetUsers.includes(value)) {
        return {
          ...prev,
          targetUsers: currentTargetUsers.filter((user) => user !== value),
        };
      } else {
        return {
          ...prev,
          targetUsers: [...currentTargetUsers, value],
        };
      }
    });
  };

  const handleSave = async () => {
    if (!formData.message || !formData.notificationType || !formData.targetUsers?.length) {
      notify({
        message: "Missing fields",
        description: "Please fill all required fields",
        type: "warning",
      });
      return;
    }

    const payload = {
      user_type: formData.targetUsers, // array of user types
      message: formData.message,
      notification_type: formData.notificationType,
    };

    const result = await dispatch(sendNotificationAction(payload));
    dispatch(fetchAllNotificationsAction());

    if (result.success) {
      notify({
        message: "Notification sent",
        description: "Notification sent successfully.",
        type: "success",
      });
      onClose();
    } else {
      notify({
        message: "Error",
        description: result.error || "Failed to send notification",
        type: "error",
      });
    }
  };

  return (
    <Box>
      <Box mb={2}>
        <Text fontSize="sm" color="#8D93A1" fontWeight="medium" mb={2}>
          Target Users
        </Text>
        <HStack spacing={4}>
          {userOptions.map((user) => (
            <Checkbox
              key={user.value}
              isChecked={formData.targetUsers?.includes(user.value)}
              onChange={() => handleUserToggle(user.value)}
              sx={{
                "& .chakra-checkbox__control[data-checked]": {
                  bg: "#071D54",
                  borderColor: "#071D54",
                },
              }}
            >
              {user.label}
            </Checkbox>
          ))}
        </HStack>
      </Box>

      <ReusableInput
        label="Notification Type"
        name="notificationType"
        type="select"
        value={formData.notificationType}
        onChange={handleInputChange}
        options={[
          { value: "Admin Notification", label: "Admin Notification" },
          { value: "Profile Incomplete Reminder", label: "Profile Incomplete Reminder" },
          { value: "System Alert", label: "System Alert" },
          { value: "System Update", label: "System Update" },
          { value: "Security Alert", label: "Security Alert" },
        ]}
      />

      <ReusableInput
        label="Message"
        name="message"
        value={formData.message}
        onChange={handleInputChange}
        placeholder="Enter message"
        mb={2}
        type="textarea"
      />

      <HStack justifyContent="flex-end" spacing={4}>
        <GradientButton
          onClick={onClose}
          fontSize="15px"
          width="100px"
          height="40px"
          disabled={loading}
        >
          Close
        </GradientButton>
        <GradientButton
          onClick={handleSave}
          fontSize="15px"
          width="100px"
          height="40px"
          loading={loading}
        >
          Save
        </GradientButton>
      </HStack>
    </Box>
  );
};

export default AddNotificationDrawer;
